var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('icon-button');
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
export var IconButtonDefaultProps = {
  onClick: function () {},
  hoverState: 'default'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n    padding: 0;\n    text-align: left;\n    font-family: ", ";\n    font-weight: 500;\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n    padding: 0;\n    text-align: left;\n    font-family: ", ";\n    font-weight: 500;\n\n    ", "\n\n    ", "\n  "])), theme.FONT('sans'), function (_a) {
    var hoverState = _a.hoverState;
    return hoverState !== 'halo' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      &:hover {\n        ", ";\n        color: ", ";\n      }\n    "], ["\n      &:hover {\n        ", ";\n        color: ", ";\n      }\n    "])), theme.FILL('primary'), theme.COLOR('primary'));
  }, function (_a) {
    var disabled = _a.disabled;
    return disabled && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      opacity: 0.4;\n    "], ["\n      opacity: 0.4;\n    "])));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    flex-shrink: 0;\n    ", "\n    \n\n    ", "\n\n    ", "\n  "], ["\n    flex-shrink: 0;\n    ", "\n    \n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var usePadding = _a.usePadding;
    return usePadding && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      padding-right: ", ";\n    "], ["\n      padding-right: ", ";\n    "])), theme.UNIT(2));
  }, function (_a) {
    var hoverState = _a.hoverState;
    return hoverState === 'animate' && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        &:hover {\n          @keyframes rotation {\n            0% {\n              transform: scale(1) rotate(0deg);\n            }\n            25% {\n              transform: scale(1.1) rotate(-10deg);\n            }\n            50% {\n              transform: scale(1.1) rotate(0deg);\n            }\n            75% {\n              transform: scale(1.1) rotate(10deg);\n            }\n            100% {\n              transform: scale(1) rotate(0deg);\n            }\n          }\n          transform: scale(1.1);\n          animation: rotation 0.5s ease-in-out;\n          transition: transform 0.3s;\n        }\n    "], ["\n        &:hover {\n          @keyframes rotation {\n            0% {\n              transform: scale(1) rotate(0deg);\n            }\n            25% {\n              transform: scale(1.1) rotate(-10deg);\n            }\n            50% {\n              transform: scale(1.1) rotate(0deg);\n            }\n            75% {\n              transform: scale(1.1) rotate(10deg);\n            }\n            100% {\n              transform: scale(1) rotate(0deg);\n            }\n          }\n          transform: scale(1.1);\n          animation: rotation 0.5s ease-in-out;\n          transition: transform 0.3s;\n        }\n    "])));
  }, function (_a) {
    var hoverState = _a.hoverState;
    return hoverState === 'halo' && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding: ", ";\n      transition: background-color 0.3s;\n      border-radius: 50%;\n      \n      &:hover {\n        background-color: ", ";\n      }\n    "], ["\n      padding: ", ";\n      transition: background-color 0.3s;\n      border-radius: 50%;\n      \n      &:hover {\n        background-color: ", ";\n      }\n    "])), theme.UNIT(2), theme.COLOR('just-visible'));
  })
});
// -------- Components -------->
var My = {
  Container: styled.button(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var IconButton = function (props) {
  var className = props.className,
    children = props.children,
    icon = props.icon,
    iconSize = props.iconSize,
    iconColor = props.iconColor,
    onClick = props.onClick,
    disabled = props.disabled,
    title = props.title,
    hoverState = props.hoverState;
  return React.createElement(My.Container, {
    hoverState: hoverState,
    disabled: disabled,
    className: cls.name(className),
    onClick: onClick,
    title: title
  }, !!icon && React.createElement(My.Icon, {
    hoverState: hoverState,
    usePadding: !!children,
    color: iconColor,
    size: iconSize
  }, icon), children);
};
IconButton.defaultProps = IconButtonDefaultProps;
IconButton.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;